import React, {useEffect, useState} from 'react';
import {Card, Descriptions, Modal, Select, Space, Timeline} from 'antd';
import {useQuery} from '../../hooks/useQuery';
import {useOpenApiFpRequest} from '../../Http/useOpenApiRequest';
import {SubmissionApi, SubmissionStatus, TermApi, UserRole} from '../../scaffold';
import SubmissionSteps from '../../components/Submission/Steps';
import useAuth from '../../utils/AuthContext';
import SubmissionStatusMessage from '../../components/Submission/StatusMessage';
import SubmissionTeacherAudit from '../../components/Submission/TeacherAudit';
import SubmissionUploadPaper from '../../components/Submission/UploadPaper';
import SubmissionDistribute from '../../components/Submission/Distribute';
import SubmissionSupervisorAudit from '../../components/Submission/SupervisorAudit';
import SubmissionJudgeAudit from '../../components/Submission/JudgeAudit';
import Text from 'antd/lib/typography/Text';
import DateFormat from '../../utils/DateFormat';
import SubmissionPapers from '../../components/Submission/Papers';
import TermStatusTag from '../../components/Term/TermStatusTag';
import {useBoolean} from 'react-hanger';
import CommonApiErrorHandler from '../../utils/HttpInstance';
import SubmissionCheckerAudit from '../../components/Submission/CheckerAudit';

export default function SubmissionDetailPage() {
  const query = useQuery();
  const auth = useAuth();
  const findState = useOpenApiFpRequest(SubmissionApi, SubmissionApi.prototype.submissionFindGet);
  const updateTermState = useOpenApiFpRequest(SubmissionApi, SubmissionApi.prototype.submissionUpdateTermPost);

  const listTerm = useOpenApiFpRequest(TermApi, TermApi.prototype.termListGet);
  const [termId, setTermId] = useState<number>();
  const isDialogUpdateTerm = useBoolean(false);

  function refresh() {
    findState.requestSync({id: parseInt(query.get('id') || '0')});
    listTerm.requestSync({});
    isDialogUpdateTerm.setFalse();
  }

  useEffect(() => {
    refresh();
  }, [query.get('id')]);

  const submission = findState.data;
  const isSelf = auth.currentUser?.id === submission?.userId;
  const isSu = auth.currentUser?.role === UserRole.管理员;
  const isSupervisor = auth.currentUser?.id === submission?.supervisorId;
  const isTeacher = auth.currentUser?.id === submission?.teacherId;
  const isJudge = auth.currentUser?.id === submission?.judgeId;
  const isChecker = auth.currentUser?.id === submission?.checkerId;
  return (
    <div>
      <Card title={'申请进度'} className={'m-b-10'} loading={findState.loading}>
        {submission && submission.status && <SubmissionSteps status={submission?.status} />}
      </Card>
      {submission && (
        <React.Fragment>
          <Card className={'m-b-10'} title={'论文详情'} loading={findState.loading}>
            <div>
              {isSelf && (
                <div>
                  <SubmissionStatusMessage submission={submission} />
                  {(submission.status === SubmissionStatus.待上传论文 ||
                    submission.status === SubmissionStatus.导师审核需修改 ||
                    submission.status === SubmissionStatus.督导审批需修改 ||
                    submission.status === SubmissionStatus.待重新上传督导论文) && (
                    <SubmissionUploadPaper submission={submission} isJudgeVersion={false} refresh={refresh} />
                  )}
                  {(submission.status === SubmissionStatus.待上传盲审论文 || submission.status === SubmissionStatus.盲审审批需修改) && (
                    <SubmissionUploadPaper submission={submission} isJudgeVersion={true} refresh={refresh} />
                  )}
                </div>
              )}
              {isTeacher && (
                <div>{submission.status === SubmissionStatus.待导师审核 && <SubmissionTeacherAudit submission={submission} onSuccess={refresh} />}</div>
              )}
              {isSupervisor && (
                <div>{submission.status === SubmissionStatus.待督导审批 && <SubmissionSupervisorAudit submission={submission} onSuccess={refresh} />}</div>
              )}
              {isJudge && (
                <div>{submission.status === SubmissionStatus.待盲审审批 && <SubmissionJudgeAudit submission={submission} onSuccess={refresh} />}</div>
              )}
              {isChecker && (
                <div>{submission.status === SubmissionStatus.待论文初审 && <SubmissionCheckerAudit submission={submission} onSuccess={refresh} />}</div>
              )}
              {isSu && (
                <div>
                  {(submission.status === SubmissionStatus.待分配督导 ||
                    submission.status === SubmissionStatus.待分配盲审 ||
                    submission.status === SubmissionStatus.待分配论文初审) && <SubmissionDistribute submission={submission} refresh={refresh} />}
                </div>
              )}
              <Descriptions bordered column={2}>
                <Descriptions.Item label={'论文标题'} span={2}>
                  {submission.title}
                </Descriptions.Item>
                {!isJudge && (
                  <React.Fragment>
                    <Descriptions.Item label={'学生姓名'}>{submission.user?.name}</Descriptions.Item>
                    <Descriptions.Item label={'学号'}>{submission.user?.username}</Descriptions.Item>
                    <Descriptions.Item label={'联系方式'}>{submission.user?.telephone}</Descriptions.Item>
                    <Descriptions.Item label={'邮箱'}>{submission.user?.email}</Descriptions.Item>
                    <Descriptions.Item label={'导师姓名'}>{submission.teacher?.name}</Descriptions.Item>
                  </React.Fragment>
                )}

                <Descriptions.Item label={'申请批次'}>
                  <span>{submission.term?.name}</span>
                  {isSu && (
                    <a onClick={isDialogUpdateTerm.setTrue} style={{marginLeft: 10}}>
                      修改批次
                    </a>
                  )}
                  <Modal
                    visible={isDialogUpdateTerm.value}
                    title={'修改批次'}
                    confirmLoading={updateTermState.loading}
                    onCancel={isDialogUpdateTerm.setFalse}
                    onOk={() => {
                      if (termId)
                        updateTermState
                          .request({updateSubmissionTermModel: {id: submission?.id || 0, termId: termId}})
                          .then(refresh)
                          .catch(CommonApiErrorHandler);
                    }}>
                    <Select placeholder={'请选择批次'} value={termId} onChange={setTermId} style={{width: 300}}>
                      {listTerm.data?.map(term => (
                        <Select.Option key={term.id} value={term.id as number}>
                          <Space size={2}>
                            <TermStatusTag status={term.termStatus as any} />
                            <Text>{term.name}</Text>
                          </Space>
                          <div>
                            <Text type={'secondary'} style={{fontSize: 12}}>
                              {DateFormat.simple(term.beginTime)} 到 {DateFormat.simple(term.endTime)}
                            </Text>
                          </div>
                        </Select.Option>
                      ))}
                    </Select>
                  </Modal>
                </Descriptions.Item>
                {(isSelf || isTeacher || isSupervisor || isSu) && (
                  <Descriptions.Item label={'督导版本论文'} span={2}>
                    <SubmissionPapers submission={submission} isJudgeVersion={false} refresh={refresh} readonly />
                  </Descriptions.Item>
                )}
                {(isSelf || isTeacher || isJudge || isSu) && (
                  <Descriptions.Item label={'盲审版本论文'} span={2}>
                    <SubmissionPapers submission={submission} isJudgeVersion={true} refresh={refresh} readonly />
                  </Descriptions.Item>
                )}
              </Descriptions>
            </div>
          </Card>
          {(isSelf || isTeacher || isSu) && submission.teacherAuditedRemark && (
            <Card title={'导师审核'}>
              <Descriptions bordered column={2}>
                <Descriptions.Item label={'意见和建议'} span={2}>
                  {submission.teacherAuditedRemark}
                </Descriptions.Item>
                <Descriptions.Item label={'结论'} span={2}>
                  {submission.status === SubmissionStatus.导师审核需修改 ? '需修改' : '通过'}
                </Descriptions.Item>
              </Descriptions>
            </Card>
          )}
          {(isSelf || isSupervisor || isSu) && submission.supervisorAuditedRemark && (
            <Card title={'督导审核'}>
              <Descriptions bordered column={2}>
                <Descriptions.Item label={'论文存在的主要问题'} span={2}>
                  {submission.supervisorAuditedRemark}
                </Descriptions.Item>
                <Descriptions.Item label={'结论'} span={2}>
                  {submission.supervisorConclusion === 3 && '论文存在较大缺陷，须作重大修改，延期半年后重新提交督导老师（提交时附上修改说明)'}
                  {submission.supervisorConclusion === 2 && '论文存在一定问题，根据督导意见修改（一个月内完成）再次提交督导（提交时附上修改说明）'}
                  {submission.supervisorConclusion === 1 && '达到论文要求，作稍许修改后可以进入盲审阶段。'}
                </Descriptions.Item>
              </Descriptions>
            </Card>
          )}
          {(isSelf || isChecker || isSu) && submission.checkerAuditedRemark && (
            <Card title={'论文初审'} className={'m-t-10'}>
              <Descriptions bordered column={2}>
                <Descriptions.Item label={'存在的主要问题'} span={2}>
                  {submission.checkerAuditedRemark}
                </Descriptions.Item>
              </Descriptions>
            </Card>
          )}
          {(isSelf || isJudge || isSu) && submission.judgeAuditedRemark && (
            <Card title={'盲审审核'}>
              <Descriptions bordered column={1}>
                <Descriptions.Item label={'总体评价'} span={2}>
                  {submission.judgeAuditedRemark}
                </Descriptions.Item>
                <Descriptions.Item label={'修改意见'} span={2}>
                  {submission.judgeAuditedAdvice}
                </Descriptions.Item>
                <Descriptions.Item label={'1.选题与综述 (10%)'}>{submission.score01} 分</Descriptions.Item>
                <Descriptions.Item label={'2.基础知识 (10%)'}>{submission.score02} 分</Descriptions.Item>
                <Descriptions.Item label={'3.方法与能力 (30%)'}>{submission.score03} 分</Descriptions.Item>
                <Descriptions.Item label={'4.实践与应用 (40%)'}>{submission.score04} 分</Descriptions.Item>
                <Descriptions.Item label={'5.写作质量 (10%)'}>{submission.score05} 分</Descriptions.Item>
                <Descriptions.Item label={'总分'}>{submission.totalScore} 分</Descriptions.Item>
              </Descriptions>
            </Card>
          )}
        </React.Fragment>
      )}

      {auth.currentUser?.role === UserRole.管理员 && (
        <Card loading={findState.loading}>
          {submission?.logs && (
            <Timeline>
              {submission.logs.map(log => (
                <Timeline.Item key={log.id}>
                  <Space>
                    <Text>{DateFormat.full(log.createdTime)}</Text>
                    <Text strong>{log.title}</Text>
                  </Space>
                  <div>
                    <Text type={'secondary'}>{log.remark}</Text>
                  </div>
                </Timeline.Item>
              ))}
            </Timeline>
          )}
        </Card>
      )}
    </div>
  );
}
